var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-auto mt-3",
    attrs: {
      "outlined": "",
      "elevation": "3",
      "rounded": "lg",
      "max-width": "1000"
    }
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.atualizarDadosDoProfissional.apply(null, arguments);
      }
    }
  }, [_c('v-card-title', {
    staticClass: "d-flex justify-center"
  }, [_c('v-icon', {
    staticClass: "p-2"
  }, [_vm._v("mdi-account")]), _vm._v(" Atualização Cadastral ")], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome*",
      "outlined": "",
      "readonly": "",
      "hide-details": "auto",
      "dense": ""
    },
    model: {
      value: _vm.dados.nome,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "nome", $$v);
      },
      expression: "dados.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Social",
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on;
              return [_c('v-icon', _vm._g({}, on), [_vm._v(" mdi-help-circle-outline ")])];
            }
          }])
        }, [_vm._v(" Nome social é a designação pela qual a pessoa travesti ou transexual se identifica e é socialmente reconhecida. "), _c('br'), _vm._v(" DEVERÁ SER COMPOSTO POR PRENOME, ACRESCIDO DO(S) SOBRENOME(S) FAMILIAR(ES) CONSTANTE(S) DO NOME CIVIL,"), _c('br'), _vm._v(" não podendo ser irreverente ou atentar contra o pudor. ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dados.nomeSocial,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "nomeSocial", $$v);
      },
      expression: "dados.nomeSocial"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "dense": "",
      "outlined": "",
      "readonly": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.dados.email,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "email", $$v);
      },
      expression: "dados.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail Secundário",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "252",
      "rules": [function (v) {
        return !v || _vm.$email(v);
      }]
    },
    model: {
      value: _vm.dados.emailSecundario,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "emailSecundario", $$v);
      },
      expression: "dados.emailSecundario"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '(##) #####-####',
      expression: "'(##) #####-####'"
    }],
    attrs: {
      "label": "Telefone*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "hint": "Número que seja de prefrência WhatsApp",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$length(v, 15);
      }]
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('scae-autofill-tooltip', {
          attrs: {
            "message": "Preencha apenas com números. O sistema aplicará automaticamente a máscara no formato (xx) xxxxx-xxxx."
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dados.telefone,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "telefone", $$v);
      },
      expression: "dados.telefone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Origem*",
      "dense": "",
      "outlined": "",
      "readonly": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.dados.origem,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "origem", $$v);
      },
      expression: "dados.origem"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.labelVwEo,
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "readonly": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.dados.vwEoNome,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "vwEoNome", $$v);
      },
      expression: "dados.vwEoNome"
    }
  })], 1), _vm.origemEscola || _vm.origemEscolaCargo ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Escola*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "readonly": ""
    },
    model: {
      value: _vm.dados.escola,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "escola", $$v);
      },
      expression: "dados.escola"
    }
  })], 1) : _vm._e(), !_vm.origemEscola ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.lista.setores,
      "item-value": "id",
      "item-text": "nome",
      "label": "Setor*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "rules": [function (v) {
        return _vm.$requiredIfTrue(v, !_vm.origemEscola);
      }]
    },
    model: {
      value: _vm.dados.setor,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "setor", $$v);
      },
      expression: "dados.setor"
    }
  })], 1) : _vm._e(), !_vm.origemEscola ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.lista.funcoes,
      "item-value": "id",
      "item-text": "nome",
      "label": "Função*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "rules": [function (v) {
        return _vm.$requiredIfTrue(v, !_vm.origemEscola);
      }]
    },
    model: {
      value: _vm.dados.funcao,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "funcao", $$v);
      },
      expression: "dados.funcao"
    }
  })], 1) : _vm._e(), _vm.origemEscola ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Função*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "readonly": ""
    },
    model: {
      value: _vm.dados.funcaoDescricao,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "funcaoDescricao", $$v);
      },
      expression: "dados.funcaoDescricao"
    }
  })], 1) : _vm._e(), _vm.origemEscola ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.lista.disciplinas,
      "item-value": "id",
      "item-text": "nome",
      "label": "Disciplina*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "rules": [function (v) {
        return _vm.$requiredIfTrue(v, _vm.origemEscola);
      }]
    },
    model: {
      value: _vm.dados.disciplina,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "disciplina", $$v);
      },
      expression: "dados.disciplina"
    }
  })], 1) : _vm._e()], 1)], 1), _c('v-card-actions', {
    staticClass: "d-flex justify-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }